"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePagination = TablePagination;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const crate_1 = require("@tcc/crate");
const i18n_1 = require("@tcc/i18n");
const tablePagination_css_1 = require("./tablePagination.css");
const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];
function TablePagination({ table, pageSizeOptions }) {
    const { pageIndex, pageSize } = table.getState().pagination;
    const totalItems = table.getRowCount();
    const start = pageIndex * pageSize + 1;
    const end = Math.min((pageIndex + 1) * pageSize, totalItems);
    const mappedPageSizeOptions = (0, react_1.useMemo)(() => (pageSizeOptions || DEFAULT_PAGE_SIZE_OPTIONS).map((size) => ({
        id: size,
        value: String(size),
    })), [pageSizeOptions]);
    const setPageSize = (0, react_1.useCallback)((size) => {
        table.setPageSize(size);
    }, [table]);
    return (react_1.default.createElement("div", { className: tablePagination_css_1.tablePagination },
        react_1.default.createElement("div", { className: tablePagination_css_1.rowsPerPage },
            react_1.default.createElement("span", null,
                (0, i18n_1.getMessage)('table.pagination.rowsPerPage'),
                ": "),
            react_1.default.createElement(crate_1.Dropdown, { borderless: true, options: mappedPageSizeOptions, value: pageSize, setValue: (value) => setPageSize(Number(value)) })),
        react_1.default.createElement("div", { className: tablePagination_css_1.pageControls },
            react_1.default.createElement("span", { "data-test-id": "fds-table-pagination-counter" },
                react_1.default.createElement("strong", null,
                    start,
                    " - ",
                    end),
                ' ',
                (0, i18n_1.getMessage)('table.pagination.of'),
                " ",
                totalItems),
            react_1.default.createElement("div", null,
                react_1.default.createElement(crate_1.Button, { type: "button", testId: "fds-table-pagination-prev-button", mode: "link", onClick: table.previousPage, disabled: !table.getCanPreviousPage() },
                    react_1.default.createElement(crate_1.Icon, { glyph: crate_1.Icon.set.ARROW_LEFT })),
                react_1.default.createElement(crate_1.Button, { type: "button", testId: "fds-table-pagination-next-button", mode: "link", onClick: table.nextPage, disabled: !table.getCanNextPage() },
                    react_1.default.createElement(crate_1.Icon, { glyph: crate_1.Icon.set.ARROW_RIGHT }))))));
}
